<template>
  <clinician-app-layout>
    <template #header>
      <div
        class="pb-5 max-w-6xl mx-auto border-gray-200 sm:flex sm:items-center sm:justify-between"
      >
        <h2 class="text-3xl text-vice-teal-900 font-semibold leading-tight">Courses</h2>
        <div class="mt-3 flex sm:mt-0 sm:ml-4">
          <inertia-link
            class="
              ml-3
              inline-flex
              items-center
              px-4
              py-2
              border border-transparent
              rounded-md
              shadow-sm
              text-md
              font-medium
              text-white
              bg-vice-teal-600
              hover:bg-vice-teal-700
              focus:outline-none
              focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500
            "
            :href="route('admin.learning-courses.create')"
          >
            Create course
          </inertia-link>
        </div>
      </div>
    </template>

    <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 py-6">
      <div class="bg-white border shadow rounded-lg overflow-hidden">
        <table class="min-w-full list-table">
          <thead class="bg-gray-50 border-b">
            <tr>
              <th class="p-6 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Title
              </th>
              <th
                class="
                  px-3
                  py-6
                  text-center text-xs
                  font-medium
                  text-gray-500
                  uppercase
                  tracking-wider
                "
              >
                Status
              </th>
              <th
                class="
                  px-3
                  py-6
                  text-center text-xs
                  font-medium
                  text-gray-500
                  uppercase
                  tracking-wider
                "
              >
                Delivery
              </th>
              <th
                class="
                  px-3
                  py-6
                  text-center text-xs
                  font-medium
                  text-gray-500
                  uppercase
                  tracking-wider
                "
              >
                Clinicians
              </th>
              <th
                class="
                  px-3
                  py-6
                  text-center text-xs
                  font-medium
                  text-gray-500
                  uppercase
                  tracking-wider
                "
              >
                Students
              </th>
              <th
                class="
                  px-3
                  py-6
                  text-center text-xs
                  font-medium
                  text-gray-500
                  uppercase
                  tracking-wider
                "
              >
                Sessions
              </th>
              <th
                class="
                  px-3
                  py-6
                  text-center text-xs
                  font-medium
                  text-gray-500
                  uppercase
                  tracking-wider
                "
              >
                Created
              </th>
              <th
                class="
                  px-3
                  py-6
                  text-center text-xs
                  font-medium
                  text-gray-500
                  uppercase
                  tracking-wider
                "
              >
                Actions
              </th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200" v-if="courses?.length">
            <tr class="" v-for="course in courses" :key="course.id">
              <td class="px-4 py-4 max-w-14">
                <div class="pl-2 flex items-center min-h-3 text-sm text-gray-900 font-semibold">
                  <inertia-link
                    :href="route('admin.learning-courses.show', course.id)"
                    class="text-vice-teal-700 hover:text-vice-teal-900"
                  >
                    {{ course.title }}
                  </inertia-link>
                </div>
              </td>
              <td class="px-4 py-4 text-xxs text-center">
                <span
                  class="px-2 py-0.5 uppercase inline-flex leading-5 font-semibold rounded-full"
                  :class="badgeClass(course.status)"
                >
                  {{ course.status }}
                </span>
              </td>
              <td class="px-4 py-4 whitespace-nowrap text-sm text-center text-gray-700">
                {{ deliveryType(course.delivery_type) }}
              </td>
              <td class="px-4 py-4 whitespace-nowrap text-sm text-center text-gray-700">
                {{ course.clinicians_count }}
              </td>
              <td class="px-4 py-4 whitespace-nowrap text-sm text-center text-gray-700">
                {{ course.students_count }}
              </td>
              <td class="px-4 py-4 whitespace-nowrap text-sm text-center text-gray-700">
                {{ course.sessions_count }}
              </td>
              <td class="px-4 py-4 whitespace-nowrap text-sm text-center text-gray-500">
                {{ formatDate(course.created_at) }}
              </td>
              <td class="pr-4 whitespace-nowrap text-right text-sm font-medium space-x-4">
                <inertia-link
                  :href="route('admin.learning-courses.show', course.id)"
                  class="text-vice-teal-700 hover:text-vice-teal-900"
                >
                  Show
                </inertia-link>
                <inertia-link
                  :href="route('admin.learning-courses.edit', course.id)"
                  class="text-vice-teal-700 hover:text-vice-teal-900"
                >
                  Edit
                </inertia-link>
                <button
                  class="text-red-600 hover:text-red-800 pr-2"
                  @click="courseToDestroyId = course.id"
                >
                  Delete
                </button>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td class="px-4 py-8 text-center text-gray-500" colspan="7">No courses found.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <!--      <div v-if="courses?.links?.length" class="mt-4 flex flex-wrap gap-1">-->
      <!--        <inertia-link-->
      <!--          v-for="(link, i) in courses.links"-->
      <!--          :key="i"-->
      <!--          :href="link.url || '#'"-->
      <!--          class="px-3 py-1 text-xs rounded border"-->
      <!--          :class="{-->
      <!--            'bg-vice-teal-600 text-white border-vice-teal-600': link.active,-->
      <!--            'text-gray-600 border-gray-200 hover:bg-gray-50': !link.active,-->
      <!--            'pointer-events-none opacity-50': !link.url,-->
      <!--          }"-->
      <!--        >-->
      <!--          <span v-html="link.label"></span>-->
      <!--        </inertia-link>-->
      <!--      </div>-->
    </div>
    <TransitionRoot as="template" :show="destroyModal">
      <Dialog
        as="div"
        class="fixed zoom-80 z-20 inset-0 overflow-y-auto"
        @close="courseToDestroyId = null"
      >
        <div
          class="
            flex
            items-end
            justify-center
            min-h-screen
            pt-4
            px-4
            pb-20
            text-center
            sm:block
            sm:p-0
          "
        >
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0"
            enter-to="opacity-100"
            leave="ease-in duration-200"
            leave-from="opacity-100"
            leave-to="opacity-0"
          >
            <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </TransitionChild>

          <!-- This element is to trick the browser into centering the modal contents. -->
          <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
            &#8203;
          </span>
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div
              class="
                inline-block
                align-bottom
                bg-white
                rounded-lg
                px-4
                pt-5
                pb-4
                text-left
                overflow-hidden
                shadow-xl
                transform
                transition-all
                sm:my-8
                sm:align-middle
                sm:max-w-lg
                sm:w-full
                sm:p-6
              "
            >
              <div class="p-2">
                <h3 class="text-lg leading-6 font-medium text-gray-900">Delete course</h3>
                <div class="mt-2 max-w-xl text-sm text-gray-500">
                  <p>You are about to remove the course. Confirm removing?</p>
                </div>
                <div class="mt-5">
                  <inertia-link
                    data-cy="delete-session-confirm"
                    @click="destroy(destroyModal)"
                    method="post"
                    type="button"
                    class="
                      inline-flex
                      items-center
                      justify-center
                      px-4
                      py-2
                      border border-transparent
                      font-medium
                      rounded-md
                      text-red-700
                      bg-red-100
                      hover:bg-red-200
                      focus:outline-none
                      focus:ring-2 focus:ring-offset-2 focus:ring-red-500
                      sm:text-sm
                    "
                  >
                    Delete course
                  </inertia-link>
                </div>
              </div>
            </div>
          </TransitionChild>
        </div>
      </Dialog>
    </TransitionRoot>
  </clinician-app-layout>
</template>

<script>
import { Dialog, DialogOverlay, TransitionChild, TransitionRoot } from '@headlessui/vue';
import ClinicianAppLayout from '@/Layouts/ClinicianAppLayout.vue';

export default {
  components: { DialogOverlay, TransitionChild, Dialog, TransitionRoot, ClinicianAppLayout },
  props: {
    courses: Object,
  },
  data() {
    return { courseToDestroyId: null };
  },
  computed: {
    destroyModal() {
      return this.courseToDestroyId !== null;
    },
  },
  methods: {
    destroy() {
      this.$inertia.delete(route('admin.learning-courses.destroy', this.courseToDestroyId));
      this.courseToDestroyId = null;
    },
    deliveryType(type) {
      switch (type) {
        case 'on_demand':
          return 'On demand';
        default:
          return 'Live';
      }
    },
    badgeClass(status) {
      switch (status) {
        case 'published':
          return 'bg-green-100 text-green-800';
        case 'archived':
          return 'bg-gray-200 text-gray-700';
        default:
          return 'bg-vice-yellow text-vice-dark-yellow';
      }
    },
    formatDate(dateStr) {
      try {
        return new Date(dateStr).toLocaleDateString();
      } catch (e) {
        return dateStr;
      }
    },
  },
};
</script>
<style scoped>
.table-row-h {
  min-height: 15rem;
}
</style>
